import { ThemeProvider, createTheme } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SnackbarProvider } from 'notistack';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AuthContext } from './contexts/AuthContext';
import { useContext } from 'react';
import { green, yellow } from '@mui/material/colors';
import { NotificacoesProvider } from './contexts/NotificacoesContext';
import "./App.css"
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import NotificadorAtualizacao from './components/NotificadorAtualizacao';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FluxoProvider } from './contexts/FlowContext';
import { ConfirmProvider } from "material-ui-confirm";
import { SearchProvider } from './contexts/SearchContext';
import privateRoutes from './routes/privateRoutes';
import publicRoutes from './routes/publicRoutes';

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: twentyFourHoursInMs,
    },
  },
});

const defaultTheme = createTheme({
  palette: {
    background: {
      default: '#F5F5F5'
    },
    primary: {
      main: green[900],
    },
    secondary: yellow
  },
  components: {
    MuiContainer: {
      defaultProps: {
        maxWidth: 'xl',
      },
    },
  },
}
);

function App() {

  const { isAuth } = useContext(AuthContext);

  const router = createBrowserRouter([
    isAuth ? privateRoutes() : {}, ...publicRoutes(),
  ]);

  return (
    <SnackbarProvider>

      <NotificadorAtualizacao />

      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={defaultTheme}>
          <DndProvider backend={HTML5Backend}>
            <NotificacoesProvider>
              <SearchProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <ConfirmProvider>
                    <FluxoProvider>

                        <RouterProvider router={router} />

                    </FluxoProvider>
                  </ConfirmProvider>
                </LocalizationProvider>
              </SearchProvider>
            </NotificacoesProvider>
          </DndProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  );
}

export default App;
